export default {
  namespaced: true,
  state: {
    sender: {
      consignor: { },
    }
  },
  getters: {
    sender: state => state.sender
  },
  actions: {
    resetCurrentDeclaration: (context, keepSender) => {
      var sender = keepSender ? { ...context.state.sender } : {};
      context.commit('resetCurrentDeclaration', sender);
    },
    resetVOECNumber: (context) => {
      context.commit('resetVOECNumber');
    },
    setSender: (context, sender) => {
      context.commit("setSender", sender);
    }
  },
  mutations: {
    resetCurrentDeclaration: (state, sender) => {
      state.sender = sender;
    },
    resetVOECNumber: (state) => {
      state.sender.voecNumber = null;
  },
    setSender: (state, sender) => {
      state.sender = { ...sender }; //make a "deep" copy
    }
  }
}
